import React, { useEffect, useState } from "react";
import { Card, Row, Col, Container } from "react-bootstrap";
import { getAllAlbums } from "../../api/requests";
import { useNavigate } from "react-router-dom";

const AlbumList = () => {
    const [albums, setAlbums] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        getAllAlbums().then(setAlbums).catch(console.error);
    }, []);

    return (
        <Container>
            <h1>Alben</h1>
            <Row>
                {albums.map(album => (
                    <Col key={album.id} sm={6} md={4} lg={3}>
                        <Card onClick={() => navigate(`/album/${album.id}`)} style={{ cursor: 'pointer' }}>
                            <Card.Body>
                                <Card.Title>{album.title}</Card.Title>
                                <Card.Text className="plain-text">{album.description}</Card.Text>
                                <Card.Text><small>{album.is_public ? "Öffentlich" : "Privat"}</small></Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default AlbumList;
